import React from 'react'

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			console.log(localStorage.getItem('nonce'))
			return (
				<div className="error">
					<h1>Oops! Something went wrong.</h1>
					<p><a className="button" href="/">Click Here To Return Home</a></p>
				</div>);
		}
		return this.props.children; 
	}
}
export default ErrorBoundary